import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import {
    MeineDatenVmForKundeComponent
} from './components/meine-daten-vm-for-kunde/meine-daten-vm-for-kunde.component';
import { RouteNames } from '../../route.name';
import { InsightSharedModule } from '../insight-shared/insight-shared.module';
import { BasisDatenComponent } from './components/meine-daten/basisdaten/basisdaten.component';
import { KundenBasisdatenComponent } from './components/meine-daten/kd-basisdaten/kd-basisdaten.component';
import { BenutzerverwaltungModule } from '../benutzerverwaltung/benutzerverwaltung.module';
import { MeineDatenVmComponent } from './components/meine-daten-vm/meinedaten-vm.component';
import { MeineDatenComponent } from './components/meine-daten/meinedaten.component';

const routes: Routes = [
    {
        path: RouteNames.MYDATA,
        children: [
            {
                path: RouteNames.BASE,
                component: MeineDatenVmComponent,
            },
        ]
    },
    {
        path: RouteNames.MEINEDATEN,
        children: [
            {
                path: RouteNames.BASE,
                redirectTo: RouteNames.PROFILE,
                pathMatch: 'full',
            },
            {
                path: RouteNames.SUB_PAGE,
                component: MeineDatenComponent,
            },
        ],
    },
    {
        path: RouteNames.KUNDENDATEN,
        children: [
            {
                path: RouteNames.BASE,
                redirectTo: RouteNames.PROFILE,
                pathMatch: 'full',
            },
            {
                path: RouteNames.SUB_PAGE,
                component: MeineDatenVmForKundeComponent,
            },
        ],
    }
];

@NgModule({
    declarations: [
        MeineDatenComponent,
        MeineDatenVmComponent,
        MeineDatenVmForKundeComponent,
        BasisDatenComponent,
        KundenBasisdatenComponent
    ],
    imports: [
        CommonModule,
        InsightSharedModule,
        RouterModule.forChild(routes),
        BenutzerverwaltungModule
    ]
})
export class MeineDatenModule {
}
